// @ts-check
import React from "react";
import { Modal, ModalHeader } from 'preferral-ui/components/Modal';
import { NewReferralTagForm } from './NewReferralTagForm';

/** @typedef {{
  isOpen: boolean;
  onClose(): void;
  organizationId: string;
  onSuccess?(): void;
}} NewReferralTagModalProps */

/** @type { React.FC<NewReferralTagModalProps> } */
export const NewReferralTagModal = props => {
  const { isOpen, onClose, organizationId, onSuccess } = props;

  return (
    <Modal
      className="_NewReferralTagModal max-w-xl"
      isOpen={isOpen}
      onRequestClose={onClose}
    >
      <ModalHeader icon="tags" title="Create Referral Tag" onClose={onClose} />
      <div className="p-4">
        <NewReferralTagForm
          organizationId={organizationId}
          onSuccess={() => {
            if (onSuccess) {
              onSuccess();
            }
            onClose();
          }}
        />
      </div>
    </Modal>
  );
};
